import {createStyles} from '@mantine/core';
import React, {useEffect, useState} from 'react';

import {CenteredSpinner} from 'ui-library/Spinner';

const useStyles = createStyles((theme) => ({
  frameContainer: {
    borderRadius: theme.radius.md,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    position: 'relative',
  },
  iframe: {
    border: 'none',
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
  iframeLoading: {
    visibility: 'hidden',
  },
  loadingOverlay: {
    alignItems: 'center',
    display: 'flex',
    inset: 0,
    justifyContent: 'center',
    position: 'absolute',
  },
}));

export default function CanvasPreviewFrame({signedUrl}: {signedUrl: string}): JSX.Element {
  const {classes, cx} = useStyles();
  const [isFrameLoading, setIsFrameLoading] = useState(true);

  useEffect(() => {
    setIsFrameLoading(true);
  }, [signedUrl]);

  return (
    <div className={classes.frameContainer}>
      {isFrameLoading && (
        <div className={classes.loadingOverlay}>
          <CenteredSpinner />
        </div>
      )}
      <iframe
        sandbox="allow-same-origin allow-scripts"
        src={signedUrl}
        className={cx(classes.iframe, isFrameLoading && classes.iframeLoading)}
        title="Canvas preview"
        onLoad={() => {
          setIsFrameLoading(false);
        }}
        onError={() => {
          setIsFrameLoading(false);
        }}
      />
    </div>
  );
}
